@file:Suppress("UNREACHABLE_CODE")

package org.example.zone360.utils

import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive
import org.example.zone360.components.CancelSubscription
import org.example.zone360.components.CancelSubscriptionRequest
import org.example.zone360.components.DownloadPdfRequest
import org.example.zone360.components.GetClubWidgetDataResponse
import org.example.zone360.components.GetClubWidgetPayload
import org.example.zone360.components.SaveWidgetPayload
import org.example.zone360.components.SaveWidgetResponse
import org.example.zone360.models.AddVideoSession
import org.example.zone360.models.AdminBotRequest
import org.example.zone360.models.AdminBotResponse
import org.example.zone360.models.AdminRequestAssessmentPayload
import org.example.zone360.models.AllReadPayload
import org.example.zone360.models.AllReadResponse
import org.example.zone360.models.AssessmentRatingResponse
import org.example.zone360.models.BulkCreatePlayerResponse
import org.example.zone360.models.BulkTeamAssessmentPayload
import org.example.zone360.models.BulkTeamAssessmentResponse
import org.example.zone360.models.ChangeEmailRequest
import org.example.zone360.models.ChangeEmailResponse
import org.example.zone360.models.ChangePasswordRequest
import org.example.zone360.models.ChangePasswordResponse
import org.example.zone360.models.ChatBtResponse
import org.example.zone360.models.ClubNamesPayload
import org.example.zone360.models.ClubNamesResponse
import org.example.zone360.models.ClubWidgetPayload
import org.example.zone360.models.ClubWidgetResponse
import org.example.zone360.models.CoachChatBotResponse
import org.example.zone360.models.CommonDataResponse
import org.example.zone360.models.CommonMessageResponse
import org.example.zone360.models.CommonResponse
import org.example.zone360.models.CreateCheckout
import org.example.zone360.models.CreateClubResponse
import org.example.zone360.models.CreatePlayerResponse
import org.example.zone360.models.CustomHighlightRequest
import org.example.zone360.models.DeleteKeywordSessionRequest
import org.example.zone360.models.EditSummaryRequest
import org.example.zone360.models.EditSummaryResponse
import org.example.zone360.models.ForgotPasswordResponse
import org.example.zone360.models.GetAllTeamsResponse
import org.example.zone360.models.GetClubCoachesListResponse
import org.example.zone360.models.GetClubCoachesResponse
import org.example.zone360.models.GetClubKeywordResponse
import org.example.zone360.models.GetClubPerformanceResponse
import org.example.zone360.models.GetClubPlayerAssessmentsResponse
import org.example.zone360.models.GetClubPlayerResponse
import org.example.zone360.models.GetPlayerResponse
import org.example.zone360.models.GetProfileResponse
import org.example.zone360.models.GetSentencesResponse
import org.example.zone360.models.GetSessionKeywordsResponse
import org.example.zone360.models.GetSessionSummaryResponse
import org.example.zone360.models.GetSessionsResponse
import org.example.zone360.models.GetSessionsResponseSingle
import org.example.zone360.models.GetSingleCoachResponse
import org.example.zone360.models.GetSinglePlayerResponse
import org.example.zone360.models.SessionResponse
import org.example.zone360.models.SummaryAnalysisResponse
import org.example.zone360.models.CoachChatbotRequest
import org.example.zone360.models.CoachWidgetResponse
import org.example.zone360.models.CommonNullResponse
import org.example.zone360.models.CommonSingleDataResponse
import org.example.zone360.models.CommonSingleResponse
import org.example.zone360.models.CreateKeywordsResponse
import org.example.zone360.models.CreateNamesPayload
import org.example.zone360.models.CreateNamesResponse
import org.example.zone360.models.CreateTeamResponse
import org.example.zone360.models.CustomKeywordPayload
import org.example.zone360.models.CustomKeywordsResponse
import org.example.zone360.models.CustomNamesPayload
import org.example.zone360.models.DeleteClubTeamResponse
import org.example.zone360.models.DeleteSeasonPayload
import org.example.zone360.models.DeleteSeasonResponse
import org.example.zone360.models.DisableUserPayload
import org.example.zone360.models.ExistingAssessmentPayload
import org.example.zone360.models.ExistingAssessmentResponse
import org.example.zone360.models.GetClubSeasonsResponse
import org.example.zone360.models.GetCustomNamesResponse
import org.example.zone360.models.GetNamesByIdPayload
import org.example.zone360.models.GetNamesByIdResponse
import org.example.zone360.models.GetWidgetCoachProfilePayload
import org.example.zone360.models.KeywordsPayload
import org.example.zone360.models.NotificationsPayload
import org.example.zone360.models.NotificationsResponse
import org.example.zone360.models.PlayerChatbotData
import org.example.zone360.models.PlayerChatbotResponse
import org.example.zone360.models.RemoveUserSeasonData
import org.example.zone360.models.RemoveUserSeasonPayload
import org.example.zone360.models.SaveClubSeasonPayload
import org.example.zone360.models.SaveClubSeasonResponse
import org.example.zone360.models.SingleClubWidgetPayload
import org.example.zone360.models.SingleClubWidgetResponse
import org.example.zone360.models.SummarizeAssessmentPayload
import org.example.zone360.models.SummarizePlayerAssessmentResponse
import org.example.zone360.models.UpdateUserDataResponse
import org.example.zone360.models.UploadClubImage
import org.example.zone360.models.UserData
import org.example.zone360.models.WidgetDetailPayload
import org.example.zone360.models.WidgetDetailResponse
import org.w3c.dom.url.URL
import org.w3c.fetch.Headers
import org.w3c.fetch.RequestInit
import org.w3c.files.File
import org.w3c.xhr.FormData
import kotlin.coroutines.cancellation.CancellationException
import kotlin.js.Promise

enum class APIMETHODS { GET, POST, DELETE }

var accessToken: String? = null


fun saveAccessToken(token: String) {
    window.localStorage.setItem("accessToken", token)
}

fun loadAccessToken(): String? {
    return window.localStorage.getItem("accessToken")?.takeIf { it.isNotEmpty() }
}


suspend fun httpRequest(
    url: String,
    method: APIMETHODS,
    body: ByteArray? = null,
    headers: Map<String, String>? = null,
): String {
    return try {
        val bodyString = body?.decodeToString()

        val requestInit = RequestInit(
            method = method.name,
            headers = Headers().apply {
                headers?.forEach { (key, value) -> append(key, value) }
            },
            body = bodyString?.takeIf { method != APIMETHODS.GET }
        )

        val response = window.fetch(url, requestInit).await()

        //  ALWAYS read response first
        val responseText = response.text().await()

        if (response.status == 401.toShort()) {
            redirectToLogin()
            throw IllegalStateException("HTTP 401 Unauthorized for $url")
        }

        //  Now you can still access error body
        if (!response.ok) {
            return responseText   // <-- return error body instead of throwing
        }

        responseText

    } catch (e: CancellationException) {
        throw e
    } catch (e: Exception) {
        throw IllegalStateException("Request failed for $url: ${e.message ?: "unknown network error"}", e)
    }
}

@JsName("TextDecoder")
external class TextDecoder {
    fun decode(input: dynamic): String
}
private val streamJson = Json {
    ignoreUnknownKeys = true
}
suspend fun httpRequestStream(
    url: String,
    method: APIMETHODS,
    body: ByteArray? = null,
    headers: Map<String, String>? = null,
    onEvent: (AdminBotResponse) -> Unit,
    onError: (String) -> Unit
) {
    try {
        val bodyString = body?.decodeToString()

        val requestInit = RequestInit(
            method = method.name,
            headers = Headers().apply {
                headers?.forEach { (key, value) ->
                    append(key, value)
                }
            },
            body = bodyString?.takeIf { method != APIMETHODS.GET }
        )

        val response = window.fetch(url, requestInit).await()

        if (response.status == 401.toShort()) {
            redirectToLogin()
            return
        }

        if (!response.ok) {
            val errorBody = try {
                response.text().await()
            } catch (e: Throwable) {
                ""
            }

            onError(errorBody.ifBlank { "HTTP ${response.status}" })
            return
        }

        val reader = response.body?.getReader()
            ?: throw Exception("Empty response stream")

        val decoder = TextDecoder()

        var buffer = ""

        while (true) {
            val chunk = reader.read()
                .unsafeCast<Promise<dynamic>>()
                .await()

            if (chunk.done) break

            buffer += decoder.decode(chunk.value)

            val lines = buffer.split("\n").toMutableList()
            buffer = lines.removeLastOrNull() ?: ""

            lines.forEach { line ->
                if (line.isBlank()) return@forEach

                try {
                    val trimmed = line.trim()

                    if (!trimmed.startsWith("data:")) {
                        return@forEach
                    }

                    val json = trimmed.removePrefix("data:").trim()

                    val event =
                        streamJson.decodeFromString<AdminBotResponse>(json)
                    onEvent(event)

                } catch (e: Exception) {
                    console.error("Parse error", e)
                }
            }
        }

    } catch (e: Throwable) {
        console.error("Stream failed", e)
        throw e
    }
}

suspend fun httpRequest1(
    url: String,
    method: APIMETHODS,
    body: dynamic = null,
    headers: Map<String, String>? = null,
): String? {
    return try {
        val requestHeaders = Headers().apply {
            headers?.forEach { (key, value) ->
                if (!(body is FormData && key.equals("Content-Type", ignoreCase = true))) {
                    append(key, value)
                }
            }
        }

        val requestInit = RequestInit(
            method = method.name, headers = requestHeaders, body = when (body) {
                is ByteArray -> body.decodeToString()
                is FormData -> body
                else -> null
            }
        )

        val response = window.fetch(url, requestInit).await()
        val responseText = response.text().await()

        if (response.status == 401.toShort()) {
            redirectToLogin()
            return null
        }

        if (!response.ok) {
            return responseText  // return error body instead of throwing
        }

        responseText
    } catch (e: Exception) {
        null
    }
}


fun redirectToLogin() {
    console.log("Redirecting to login page due to 401 Unauthorized.")
    window.location.href = "/login"
}


fun getHeaders(): Map<String, String> {
    return loadAccessToken()?.let {
        mapOf(
            "Authorization" to "Bearer $it", "Content-Type" to "application/json" // ✅ add this line
        )
    } ?: mapOf("Content-Type" to "application/json") // fallback if no token
}


suspend fun login(email: String, password: String): UserData {
    val jsonData = """{
        "email": "$email",
        "password": "$password"
    }"""

    val response: UserData = httpRequest(
        APIEndPoints.Name.login, APIMETHODS.POST, body = jsonData.encodeToByteArray()
    ).parseData()

    accessToken = response.accessToken
    // Save the token to localStorage
    accessToken?.let { saveAccessToken(it) }

    return response
}

suspend fun changePassword(
    email: String,
    currentPassword: String,
    newPassword: String,
    confirmPassword: String,
): ChangePasswordResponse {
    require(newPassword == confirmPassword) {
        "New password and confirm password do not match"
    }

    val request = ChangePasswordRequest(
        email = email, password = currentPassword, newPassword = newPassword
    )

    val jsonData = Json.encodeToString(request)

    return httpRequest(
        APIEndPoints.Name.changePassword,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun changeEmail(
    email: String,
    userID: String,
    organization: String,

    ): ChangeEmailResponse {

    val request = ChangeEmailRequest(
        email = email, userID = userID, organization = organization
    )

    val jsonData = Json.encodeToString(request)

    return httpRequest(
        APIEndPoints.Name.changeEmail,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun createClubDirector(
    email: String,
    password: String,
    firstName: String,
    lastName: String,
): CreateClubResponse {
    val jsonData = """{
        "email": "$email",
        "password": "$password",
        "firstName": "$firstName",
        "lastName": "$lastName",
        "clubName": "${AppGlobal.userData.organization}"
    }"""
    return httpRequest(
        APIEndPoints.Name.create_club_director,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun createClubAdmin(
    email: String,
    password: String,
    firstName: String,
    lastName: String,
    clubName: String,
): CreateClubResponse {
    val jsonData = """{
        "email": "$email",
        "password": "$password",
        "firstName": "$firstName",
        "lastName": "$lastName",
        "clubName": "$clubName"
    }"""
    return httpRequest(
        APIEndPoints.Name.create_club_admin,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}


suspend fun forgetPassword(email: String): ForgotPasswordResponse {
    val jsonData = """{ "email": "$email" }"""

    val response: ForgotPasswordResponse = httpRequest(
        APIEndPoints.Name.forget_Password,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()

    return response
}

suspend fun getClubSession(
    organization: String,
    domainType: String,
    language: String,
    sessionType: String,
    seasonID: String,
): SessionResponse {
    val jsonData = """{
        "organization": "$organization",
        "sessionType": "$sessionType",
        "domainType": "$domainType",
        "language": "$language",
        "seasonID": "$seasonID"
    }"""

    return httpRequest(
        APIEndPoints.Name.get_Club_session,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun getClubKeyword(
    organization: String, domainType: String,
    sessionType: String,
    language: String, keyword: String,
    getSentences: Boolean,
    seasonID: String,
): GetClubKeywordResponse {
    val jsonData = """{
        "organization": "$organization",
        "domainType": "$domainType",
        "sessionType": "$sessionType",
        "language": "$language",
        "keyword": "$keyword",
        "getSentences": $getSentences,
        "seasonID": "$seasonID"
    }"""

    return httpRequest(
        APIEndPoints.Name.get_Club_Keyword,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun getClubCoaches(
    organization: String,
    domainType: String,
    sessionType: String,
    language: String,
    seasonID: String,
): GetClubCoachesResponse {
    val jsonData = """{
        "organization": "$organization",
        "domainType": "$domainType",
        "sessionType": "$sessionType",
        "language": "$language",
        "seasonID": "$seasonID"
    }"""

    return httpRequest(
        APIEndPoints.Name.get_Club_Coaches,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}


suspend fun getSessionSummary(
    organization: String,
    userID: String,
    domainType: String,
    language: String,
    getAll: Boolean,
    isPlayer: Boolean,
    sessionType: String,
): GetSessionSummaryResponse {
    val jsonData = """{
         "organization": "$organization",
        "userID": "$userID",
        "domainType": "$domainType",
        "language": "$language",
        "getAll": $getAll,
        "isPlayer": $isPlayer,
        "sessionType": "$sessionType",
        "seasonID": "${AppGlobal.selectedSeasonId}"
    }"""

    return httpRequest(
        APIEndPoints.Name.get_Session_Summary,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun getPlayerAggregate(
    organization: String,
    domainType: String,
    language: String,
    team: List<String>,
    teamOnly: Boolean = false,
    seasonID: String,
): GetPlayerResponse {
    val jsonData = """{
        "organization": "$organization",
        "domainType": "$domainType",
        "language": "$language",
        "teamOnly": $teamOnly,
        "seasonID": "$seasonID",
        "team": ${Json.encodeToString(team)}
    }"""

    return httpRequest(
        APIEndPoints.Name.get_Player_Aggregate,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun sendEmail(
    organization: String,
    playerName: String,
    coachName: String,
    toEmail: String,
    sessionID: String,
): CommonResponse {
    val jsonData = """{
         "organization": "$organization",
        "playerName": "$playerName",
        "coachName": "$coachName",
        "toEmail": "$toEmail",
        "sessionID": "$sessionID"
    }"""

    return httpRequest(
        APIEndPoints.Name.send_Email,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun updateOrg(
    organization: String,
    oldOrganization: String,
    uid: String,
): CreatePlayerResponse {
    val formData = FormData().apply {
        append("organization", organization)
        append("oldOrganization", oldOrganization)
        append("uid", uid)
        append("role", Strings.PLAYER)
    }

    return httpRequest1(
        APIEndPoints.Name.update_org,
        APIMETHODS.POST,
        body = formData,
        headers = getHeaders() // Let browser set boundary for multipart/form-data
    ).parseData()
}

suspend fun createPlayer(
    email: String,
    firstName: String,
    lastName: String,
    imageUrl: String,
    organization: String,
    coachName: String,
    team: String,
    password: String,
    isPublicSignup: Boolean = false,

): CreatePlayerResponse {
    val jsonData = """{
        "email": "$email",
        "firstName": "$firstName",
        "lastName": "$lastName",
        "imageUrl": "$imageUrl",
        "organization": "$organization",
        "coachName": "$coachName",
        "team": "$team",
        "password": "$password",
        "isPublicSignup": $isPublicSignup,
        "seasonID": "${AppGlobal.selectedSeasonId}"
    }"""
    return httpRequest(
        APIEndPoints.Name.create_player,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData(errorField = "error")
}

suspend fun getClubPerformance(
    organization: String,
    domainType: String,
    language: String,
    sessionType: String,
    seasonID: String,
): GetClubPerformanceResponse {
    val jsonData = """{
        "organization": "$organization",
        "domainType": "$domainType",
        "language": "$language",
        "sessionType": "$sessionType",
        "seasonID": "$seasonID"
    }"""

    return httpRequest(
        APIEndPoints.Name.club_performance,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun createCoach(
    email: String,
    firstName: String,
    lastName: String,
    imageUrl: String,
    organization: String,
    teams: List<String>,
): CommonResponse {
    val jsonData = """{
            "email": "$email",
            "firstName": "$firstName",
            "lastName": "$lastName",
            "imageUrl": "$imageUrl",
            "organization": "$organization",
            "seasonID": "${AppGlobal.selectedSeasonId}",
            "teams": ${Json.encodeToString(teams)}
        }"""

    return httpRequest(
        APIEndPoints.Name.create_Coach,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData(errorField = "error")
}

suspend fun getSessions(
    sessionID: String,
    userID: String,
    domainType: String,
    language: String,
    getAll: Boolean,
    excludeAssessments: Boolean,
    getWithTagged: Boolean,
    organization: String,
    seasonID: String,
): GetSessionsResponse {
    val jsonData = """{
        "sessionID": "$sessionID",
        "userID": "$userID",
        "domainType": "$domainType",
        "language": "$language",
        "getAll": $getAll,
        "organization": "$organization",
        "excludeAssessments": $excludeAssessments,
        "getWithTagged": $getWithTagged,
        "seasonID": "$seasonID"
    }"""

    return httpRequest(
        APIEndPoints.Name.get_Sessions,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun getSingleSessions(
    organization: String,
    sessionID: String,
    userID: String,
    domainType: String,
    language: String,
    getAll: Boolean,
    excludeAssessments: Boolean,
): GetSessionsResponseSingle {
    val jsonData = """{
         "organization": "$organization",
        "sessionID": "$sessionID",
        "userID": "$userID",
        "domainType": "$domainType",
        "language": "$language",
        "getAll": $getAll,
         "excludeAssessments": $excludeAssessments
    }"""

    return httpRequest(
        APIEndPoints.Name.get_Sessions,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun getSentences(
    organization: String,
    sessionID: String,
    type: String,
): GetSentencesResponse {
    val jsonData = """{
         "organization": "$organization",
        "sessionID": "$sessionID",
        "type": "$type"
    }"""

    return httpRequest(
        APIEndPoints.Name.get_Sentences,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun getClubPlayer(organization: String, team: List<String>): GetClubPlayerResponse {
    val jsonData = """{
        "organization": "$organization",
        "seasonID": "${AppGlobal.selectedSeasonId}",
        "team": ${Json.encodeToString(team)}
    }"""

    return httpRequest(
        APIEndPoints.Name.get_Club_Players,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun getClubCoachesList(organization: String): GetClubCoachesListResponse {
    val jsonData = """{
        "organization": "$organization",
        "seasonID": "${AppGlobal.selectedSeasonId}"
    }"""

    return httpRequest(
        APIEndPoints.Name.get_Club_Coaches_List,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

// for tagging player only
suspend fun tagPlayers1(
    organization: String,
    playerID: String,
    sentenceID: String,
    isRemove: Boolean,
): CommonResponse {
    val jsonData = """{
         "organization": "$organization",
        "playerID": "$playerID",
        "sentenceID": "$sentenceID",
        "isRemove": $isRemove
    }"""

    return httpRequest(
        APIEndPoints.Name.tag_Player,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

// for tagging both coach and player
suspend fun tagUser(
    organization: String,
    sessionID: String,
    userID: String,
    sentenceID: String,
    isRemove: Boolean,
): CommonResponse {
    val jsonData = """{
         "organization": "$organization",
        "sessionID": "$sessionID",
        "userID": "$userID",
        "sentenceID": "$sentenceID",
        "isRemove": $isRemove
    }"""

    return httpRequest(
        APIEndPoints.Name.tag_User,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun updateUserData(jsonData: String): UpdateUserDataResponse {
    return httpRequest(
        APIEndPoints.Name.update_UserData,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun getProfile(organization: String, userID: String, seasonID: String): GetProfileResponse {
    val jsonData = """{
         "organization": "$organization",
        "userID": "$userID",
        "seasonID": "$seasonID"
    }"""

    return httpRequest(
        APIEndPoints.Name.get_profile,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun getSingleCoach(
    organization: String,
    domainType: String,
    sessionType: String,
    language: String,
    userID: String,
    seasonID: String,
): GetSingleCoachResponse {
    val jsonData = """{
        "organization": "$organization",
        "domainType": "$domainType",
        "sessionType": "$sessionType",
        "language": "$language",
        "userID": "$userID",
        "seasonID": "$seasonID"
    }"""

    return httpRequest(
        APIEndPoints.Name.getSingleCoach,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun chatBot(
    organization: String,
    context: String,
    domain_type: String,
    session_type: String,
    language: String,
    query: String,
    session_id: String,
    coachBot: Boolean = false,
): ChatBtResponse {
    val jsonData = """{
        "organization": "$organization",
        "context": "${context.trimIndent().replace("\n", "\\n")}",
        "domain_type": "$domain_type",
        "session_type": "$session_type",
        "language": "$language",
        "query": "$query",
        "session_id": "$session_id"
    }"""

    return httpRequest(
        APIEndPoints.Name.chatbot,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun newPlayerChatBot(
    payload: PlayerChatbotData
): PlayerChatbotResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.playerChatbot,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<PlayerChatbotResponse>()
}

suspend fun newCoachChatBot(
    payload: CoachChatbotRequest
): CoachChatBotResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.coachChatbot,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<CoachChatBotResponse>()
}

suspend fun adminBotStreamRequest(
    payload: AdminBotRequest,
    onEvent: (AdminBotResponse) -> Unit,
    onError: (String) -> Unit = {},
) {
    try {
        val jsonData = JsonConfig.default.encodeToString(payload)

        httpRequestStream(
            url = APIEndPoints.Name.chatAdminStream,
            method = APIMETHODS.POST,
            body = jsonData.encodeToByteArray(),
            headers = getHeaders(),
            onEvent = onEvent,
            onError = onError

        )
    } catch (e: Exception) {
        throw e
    } catch (e: Throwable) {
        console.error("Bot stream error", e)
        onError(e.message ?: "Something went wrong")
    }
}

suspend fun coachBotStreamRequest(
    payload: AdminBotRequest,
    onEvent: (AdminBotResponse) -> Unit,
    onError: (String) -> Unit = {}
) {
    try {
        val jsonData = JsonConfig.default.encodeToString(payload)

        httpRequestStream(
            url = APIEndPoints.Name.coach_chatbot_stream,
            method = APIMETHODS.POST,
            body = jsonData.encodeToByteArray(),
            headers = getHeaders(),
            onEvent = onEvent,
            onError = onError
        )
    } catch (e: Throwable) {
        console.error("Bot stream error", e)
        onError(e.message ?: "Something went wrong")
    }
}

suspend fun playerBotStreamRequest(
    payload: AdminBotRequest,
    onEvent: (AdminBotResponse) -> Unit,
    onError: (String) -> Unit = {}
) {
    try {
        val jsonData = JsonConfig.default.encodeToString(payload)

        httpRequestStream(
            url = APIEndPoints.Name.player_chatbot_stream,
            method = APIMETHODS.POST,
            body = jsonData.encodeToByteArray(),
            headers = getHeaders(),
            onEvent = onEvent,
            onError = onError
        )
    } catch (e: Throwable) {
        console.error("Bot stream error", e)
        onError(e.message ?: "Something went wrong")
    }
}


//suspend fun adminBotRequest(
//    payload: AdminBotRequest
//): AdminBotResponse {
//    val jsonData = JsonConfig.default.encodeToString(payload)
//
//
//    val response = httpRequest(
//        APIEndPoints.Name.adminBotRequest,
//        APIMETHODS.POST,
//        body = jsonData.encodeToByteArray(),
//        headers = getHeaders()
//    )
//
//    return response.parseData<AdminBotResponse>()
//}


suspend fun getSinglePlayer(
    domainType: String,
    language: String,
    userID: String,
    organization: String,
    seasonID: String,
): GetSinglePlayerResponse {
    val jsonData = """{
        "domainType": "$domainType",
        "language": "$language",
        "userID": "$userID",
        "organization": "$organization",
        "seasonID": "$seasonID"
    }"""

    return httpRequest(
        APIEndPoints.Name.getSinglePlayer,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun getClubPlayerAssessmentAggregate(
    organization: String,
    domainType: String,
    language: String,
    playerID: String,
): GetClubPlayerAssessmentsResponse {
    val jsonData = """{
        "organization": "$organization",
        "domainType": "$domainType",
        "language": "$language",
        "playerID": "$playerID"
    }"""

    return httpRequest(
        APIEndPoints.Name.getClubPlayerAssessment,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun requestAssessment(
    organization: String,
    coachID: String,
    playerID: String,
    coachEmail: String,
    coachName: String,
    playerEmail: String,
    requestedBy: String = "player",
    playerName: String,
): CommonDataResponse {
    val jsonData = """{
        "organization": "$organization",
        "coachID": "$coachID",
        "playerID": "$playerID",
        "coachEmail": "$coachEmail",
         "playerEmail":"$playerEmail",
        "requestedBy": "$requestedBy",
        "coachName": "$coachName",
        "playerName": "$playerName",
        "seasonID": "${AppGlobal.selectedSeasonId}"
        
    }"""

    return httpRequest(
        APIEndPoints.Name.requestAssessment,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun getPlayerAssessment(
    playerID: String,
    domainType: String,
    language: String,
    seasonID: String
): GetSessionsResponse {
    val jsonData = """{
        "playerID": "$playerID",
        "domainType": "$domainType",
        "language": "$language",
        "organization": "${AppGlobal.userData.organization}",
        "seasonID": "$seasonID"
    }"""

    return httpRequest(
        APIEndPoints.Name.getPlayerAssessments,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun getTagSentences(
    organization: String,
    domainType: String,
    language: String,
    playerID: String,
    seasonID: String,
): GetSentencesResponse {
    val jsonData = """{
        "organization": "$organization",
        "domainType": "$domainType",
        "language": "$language",
        "playerID": "$playerID",
        "seasonID": "$seasonID"
    }"""

    return httpRequest(
        APIEndPoints.Name.getTagPlayerSentences,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun getAllTeams(clubName: String, seasonID: String): GetAllTeamsResponse {

    return httpRequest(
        "${APIEndPoints.Name.get_All_Teams}?clubName=$clubName&seasonID=$seasonID",
        APIMETHODS.GET,
        headers = getHeaders()
    ).parseData()
}

suspend fun createClubTeam(
    organization: String,
    clubName: String,
    teamName: String,
    seasonId: String,
): CreateTeamResponse {
    val jsonData = """{
        "organization": "$organization",
        "clubName": "$clubName",
        "teamName": "$teamName" ,
        "seasonID": "$seasonId"
    }"""

    return httpRequest(
        APIEndPoints.Name.create_Club_Team,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun deleteClubTeam(
    teamId: String,
    teamName: String,
    organization: String,
): DeleteClubTeamResponse {

    return httpRequest(
        "${APIEndPoints.Name.delete_Club_Team}?team_id=$teamId&team_name=$teamName&organization=$organization",
        APIMETHODS.GET,
        headers = getHeaders()
    ).parseData()
}

suspend fun updateUserWithTeam(
    teamName: String,
    userID: String,
    organization: String,
    isRemove: Boolean,
    seasonID: String = AppGlobal.selectedSeasonId
): CommonResponse {
    val jsonData = """{
        "teamName": "$teamName",
        "userID": "$userID",
        "organization": "$organization",
        "isRemove": $isRemove,
        "seasonID": "$seasonID" 
    }"""

    return httpRequest(
        APIEndPoints.Name.update_User_With_Team,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun assessmentRating(
    organization: String,
    rating: String,
    userID: String,
    coachName: String,
    sessionID: String,
): AssessmentRatingResponse {
    val jsonData = """{
        "organization": "$organization",
        "rating": "$rating",
        "userID": "$userID",
        "coachName": "$coachName",
        "sessionID": "$sessionID"
    }"""

    return httpRequest(
        APIEndPoints.Name.assessment_Rating,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun uploadCoachImage(
    organization: String,
    userID: String,
    file: File,
): UpdateUserDataResponse {
    val formData = FormData()
    formData.append("organization", organization)
    formData.append("userID", userID)
    formData.append("file", file)

    return httpRequest1(
        url = APIEndPoints.Name.upload_Image,
        method = APIMETHODS.POST,
        body = formData,
        headers = getHeaders() // ✅ Include Authorization
    ).parseData()
}


suspend fun uploadClubImage(
    organization: String,
    file: File,
): UploadClubImage {
    val formData = FormData()
    formData.append("organization", organization)
    formData.append("file", file)

    return httpRequest1(
        url = APIEndPoints.Name.upload_club_Image,
        method = APIMETHODS.POST,
        body = formData,
        headers = getHeaders() // ✅ Include Authorization
    ).parseData()
}

suspend fun saveCustomHighlight(payload: CustomHighlightRequest): CommonMessageResponse {
    val jsonBody = Json.encodeToString(payload)

    return httpRequest(
        url = APIEndPoints.Name.add_Custom_Highlight,
        method = APIMETHODS.POST,
        body = jsonBody.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}

suspend fun editSummary(payload: EditSummaryRequest): EditSummaryResponse {
    val jsonBody = Json.encodeToString(payload)
    return httpRequest(
        url = APIEndPoints.Name.edit_Summary,
        method = APIMETHODS.POST,
        body = jsonBody.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()

}

suspend fun summaryAnalysis(payload: EditSummaryRequest): SummaryAnalysisResponse {
    val jsonBody = Json.encodeToString(payload)
    return httpRequest(
        url = APIEndPoints.Name.analysis_refresh,
        method = APIMETHODS.POST,
        body = jsonBody.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()

}

suspend fun updateTranscript(
    organization: String,
    sentenceID: String,
    transcript: String,
    notes: String,
    updateNotes: Boolean,
): CommonResponse {
    val jsonData = """{
        "organization": "$organization",
        "sentenceID": "$sentenceID",
        "transcript": "$transcript",
        "notes": "$notes",
        "updateNotes": $updateNotes
    }"""
    return httpRequest(
        url = APIEndPoints.Name.update_Transcript,
        method = APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()

}

suspend fun getSessionKeywords(
    organization: String,
    sessionId: String,
    userID: String,
): GetSessionKeywordsResponse {
    val jsonData = """{
        "organization": "$organization",
        "sessionID": "$sessionId",
        "userID": "$userID"
    }"""
    return httpRequest(
        url = APIEndPoints.Name.get_session_keywords,
        method = APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()

}

suspend fun createCheckoutSession(
    priceID: String, organization: String, email: String, userID: String, stripCustomerID: String
): CreateCheckout {
    val jsonData = """{
        "priceID":"$priceID",
        "organization": "$organization",
        "email": "$email",
        "userID": "$userID",
        "stripCustomerID" : "$stripCustomerID"
    }"""
    return httpRequest(
        url = APIEndPoints.Name.create_checkout,
        method = APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()

}

suspend fun createSubscriptionCheckout(
    plan: String, organization: String, email: String, userID: String, stripCustomerID: String
): CreateCheckout {
    val jsonData = """{
        "plan":"$plan",
        "organization": "$organization",
        "email": "$email",
        "userID": "$userID",
        "stripCustomerID" : "$stripCustomerID"
    }"""
    return httpRequest(
        url = APIEndPoints.Name.create_subscription,
        method = APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()

}
suspend fun cancelSubscription(): CancelSubscription {
    val jsonData = Json.encodeToString(
        CancelSubscriptionRequest(AppGlobal.userData.stripeSubscriptionID?: "")
    )
    return httpRequest(
        url = APIEndPoints.Name.cancel_subscription,
        method = APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()

}


suspend fun createCheckoutAddon(
    count: String, organization: String, email: String, userID: String, stripCustomerID: String
): CreateCheckout {
    val jsonData = """{
        "count":"$count",
        "organization": "$organization",
        "email": "$email",
        "userID": "$userID",
        "stripCustomerID" : "$stripCustomerID"
    }"""
    return httpRequest(
        url = APIEndPoints.Name.create_checkout_addon,
        method = APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()

}

suspend fun addVideoSession(
    sessionName: String,
    organization: String,
    coachName: String,
    userID: String,
    domainType: String,
    language: String,
    sessionType: String,
): AddVideoSession {
    val jsonData = """{
        "sessionName":"$sessionName",
        "organization": "$organization",
        "coachName": "$coachName",
        "userID": "$userID",
        "domainType": "$domainType",
        "language": "$language",
        "sessionType":"$sessionType",
        "seasonID": "${AppGlobal.selectedSeasonId}"
    }"""
    return httpRequest(
        url = APIEndPoints.Name.add_video_session,
        method = APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()

}

suspend fun importPlayer(
    file: File,
): BulkCreatePlayerResponse {
    val formData = FormData()
    formData.append("file", file)
    formData.append("organization", AppGlobal.userData.organization)


    return httpRequest1(
        url = APIEndPoints.Name.bulk_create_club_player,
        method = APIMETHODS.POST,
        body = formData,
        headers = getHeaders() // ✅ Include Authorization
    ).parseData(errorField = "error")
}

suspend fun importCoach(
    file: File,
): BulkCreatePlayerResponse {
    val formData = FormData()
    formData.append("file", file)
    formData.append("organization", AppGlobal.userData.organization)

    return httpRequest1(
        url = APIEndPoints.Name.bulk_create_club_coach,
        method = APIMETHODS.POST,
        body = formData,
        headers = getHeaders() // ✅ Include Authorization
    ).parseData(errorField = "error")
}

suspend fun deleteSession(
    sessionID: String,
    organization: String,
): DeleteKeywordSessionRequest {
    val jsonData = """{
        "sessionID": "$sessionID",
        "organization": "$organization"
    }"""
    return httpRequest(
        APIEndPoints.Name.delete_session,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    ).parseData()
}


suspend fun createKeywords(
    payload: KeywordsPayload
): CreateKeywordsResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.create_keywords,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<CreateKeywordsResponse>()
}

suspend fun getCustomKeyword(
    payload: CustomKeywordPayload
): CustomKeywordsResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.custom_keywords,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<CustomKeywordsResponse>()
}

suspend fun deleteClubKeywords(
    keywordID: String,
    organization: String,
): CommonResponse {

    return httpRequest(
        "${APIEndPoints.Name.delete_keyword}keywordID=$keywordID&organization=$organization",
        APIMETHODS.DELETE,
        headers = getHeaders()
    ).parseData()
}

suspend fun adminRequestAssessment(
    payload: AdminRequestAssessmentPayload
): CommonSingleResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.request_assessment,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<CommonSingleResponse>()
}

suspend fun getNotifications(
    payload: NotificationsPayload
): NotificationsResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.get_notification,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<NotificationsResponse>()
}

suspend fun updateNotifications(
    payload: AllReadPayload
): AllReadResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.update_notification,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<AllReadResponse>()
}

suspend fun bulkTeamAssessment(
    payload: BulkTeamAssessmentPayload
): BulkTeamAssessmentResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.bulk_team_assessment,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<BulkTeamAssessmentResponse>()
}

suspend fun existingAssessment(
    payload: ExistingAssessmentPayload
): ExistingAssessmentResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.existing_assessment,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<ExistingAssessmentResponse>()
}

suspend fun disableUser(
    payload: DisableUserPayload
): CommonSingleDataResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.disable_coach,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<CommonSingleDataResponse>()
}

suspend fun saveClubSeason(payload: SaveClubSeasonPayload): SaveClubSeasonResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)

    val response = httpRequest(
        APIEndPoints.Name.save_club_season,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return try {
        response.parseData<SaveClubSeasonResponse>()
    } catch (e: Exception) {
        console.error("Parse error:", e.message)
        // If response is null or parsing fails, return error with the raw response
        SaveClubSeasonResponse(error = response ?: "Failed to connect to server")
    }
}
suspend fun getClubSeason(organization: String, seasonID: String): GetClubSeasonsResponse {

    return httpRequest(
        "${APIEndPoints.Name.get_club_season}?organization=$organization",
        APIMETHODS.GET,
        headers = getHeaders()
    ).parseData()
}

suspend fun deleteClubSeason(payload: DeleteSeasonPayload): DeleteSeasonResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.delete_club_season,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<DeleteSeasonResponse>()
}

suspend fun removeUserSeason(payload: RemoveUserSeasonPayload): RemoveUserSeasonData {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.remove_user_season,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<RemoveUserSeasonData>()
}

suspend fun summarizePlayerAssessment(payload: SummarizeAssessmentPayload): SummarizePlayerAssessmentResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.summarize_player_assessment,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<SummarizePlayerAssessmentResponse>()
}

suspend fun getCustomNames(payload: CustomNamesPayload): GetCustomNamesResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.get_custom_names,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<GetCustomNamesResponse>()
}

suspend fun createNames(payload: CreateNamesPayload): CreateNamesResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.create_names,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<CreateNamesResponse>()
}

suspend fun deleteClubNames(
    nameID: String,
    organization: String,
): CommonNullResponse {

    return httpRequest(
        "${APIEndPoints.Name.delete_names}nameID=$nameID&organization=$organization",
        APIMETHODS.DELETE,
        headers = getHeaders()
    ).parseData()
}

suspend fun getClubNames(payload: ClubNamesPayload): ClubNamesResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.get_club_names,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<ClubNamesResponse>()
}

suspend fun getNamesById(payload: GetNamesByIdPayload): GetNamesByIdResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.get_names_by_id,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<GetNamesByIdResponse>()
}

suspend fun generateChatbotReport(payload: DownloadPdfRequest) {
    val jsonData = JsonConfig.default.encodeToString(payload)

    val response = window.fetch(
        APIEndPoints.Name.generate_chatbot_report,
        RequestInit(
            method = APIMETHODS.POST.name,
            headers = Headers().apply {
                getHeaders().forEach { (k, v) -> append(k, v) }
            },
            body = jsonData
        )
    ).await()

    if (!response.ok) return

    val blob = response.blob().await()
    val url = URL.createObjectURL(blob)
    val link = document.createElement("a")
    link.asDynamic().href = url
    link.asDynamic().download = "report.pdf"
    link.asDynamic().click()
    URL.revokeObjectURL(url)
}


suspend fun getClubWidgetData(payload: ClubWidgetPayload): ClubWidgetResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.get_club_widget_overview,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<ClubWidgetResponse>()
}

suspend fun getSingleClubWidgetData(payload: SingleClubWidgetPayload): SingleClubWidgetResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.single_club_widget,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<SingleClubWidgetResponse>()
}

suspend fun saveWidgetConfig(payload: SaveWidgetPayload): SaveWidgetResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.save_widgets,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<SaveWidgetResponse>()
}

suspend fun getClubWidgets(payload: GetClubWidgetPayload): GetClubWidgetDataResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.get_club_widget_data,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<GetClubWidgetDataResponse>()
}


suspend fun getWidgetDetail(payload: WidgetDetailPayload): WidgetDetailResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.get_widget_detail,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<WidgetDetailResponse>()
}

suspend fun getCoachWidgetProfile(payload: GetWidgetCoachProfilePayload): CoachWidgetResponse {
    val jsonData = JsonConfig.default.encodeToString(payload)


    val response = httpRequest(
        APIEndPoints.Name.get_widget_coach_profile,
        APIMETHODS.POST,
        body = jsonData.encodeToByteArray(),
        headers = getHeaders()
    )

    return response.parseData<CoachWidgetResponse>()
}

//

object JsonConfig {
    val default: Json = Json {
        ignoreUnknownKeys = true
        coerceInputValues = true
    }
}



inline fun <reified T> String?.parseData(errorField: String? = null): T {
    if (this == null) throw IllegalArgumentException("Response is null")
    if (errorField != null) {
        val error = try {
            JsonConfig.default.parseToJsonElement(this).jsonObject[errorField]?.jsonPrimitive?.content
        } catch (e: Exception) { null }
        if (error != null) throw IllegalArgumentException(error)
    }
    return JsonConfig.default.decodeFromString(this)
}
